import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * WhatsNewFAB — compact circular "What's New" button, companion to the
 * WhatsApp FAB (sits immediately to its left). Config from GET /api/whats-new.
 */
export default function WhatsNewFAB() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.getWhatsNew().then((c) => { if (!cancelled) setCfg(c); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (pathname.startsWith("/dashboard") || pathname.startsWith("/login")) return null;
  if (!cfg || !cfg.effective_visible) return null;

  const label = (cfg.button_label || "What's New").trim();
  const href = (cfg.destination_url || "").trim();
  const upper = label.toUpperCase();
  const parts = upper.split(/\s+/);
  const line1 = parts[0] || "";
  const line2 = parts.slice(1).join(" ");

  const onClick = () => {
    if (!href) return;
    if (cfg.destination_type === "external" || /^https?:\/\//i.test(href)) {
      window.open(href, "_blank", "noopener");
      return;
    }
    navigate(href);
  };

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="whats-new-fab"
      aria-label={`${label}. Opens the featured content.`}
      className="fixed z-[200] bottom-6 right-[72px] md:right-[140px] flex flex-col items-center justify-center rounded-full bg-lux-bg text-lux-ink shadow-[0_4px_12px_rgba(20,16,10,0.14)] hover:shadow-[0_6px_16px_rgba(20,16,10,0.2)] transition-shadow w-12 h-12 md:w-14 md:h-14"
    >
      <span className="font-semibold text-center leading-[11px] md:leading-[13px] text-[8.5px] md:text-[10px] tracking-[0.12em] md:tracking-[0.16em]">{line1}</span>
      {line2 ? (
        <span className="font-semibold text-center leading-[11px] md:leading-[13px] text-[8.5px] md:text-[10px] tracking-[0.12em] md:tracking-[0.16em]">{line2}</span>
      ) : null}
    </button>
  );
}
